import {ApiHelper} from "../apiHelper";
import { Observable } from "rxjs";
import {BaseDao} from "./BaseDao";
import {ConstantMan} from "../constantMan";
import { LookerSignedUrlBody } from '../../models/lookerSignedUrlBody';
import { LookerEmbedCookielessSessionData } from '@looker/embed-sdk';

export class LookerDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.LOOKER, apiHelper);
    }
    public getSignedEmbedURL(reqBody: LookerSignedUrlBody): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/get-signed-embed-url';
        const headers = this.apiHelper.getDefaultHeader();
        const serviceName = this.apiHelper.getServiceName();

        return this.apiHelper.apiCall(
          url,
          'POST',
          serviceName,
          reqBody,
          headers
        );
    }

    public emailStationRep(reqBody) {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/email-station-rep';
        const headers = this.apiHelper.getDefaultHeader();

        return this.apiHelper.apiCall(
          url,
          'POST',
          null,
          reqBody,
          headers
        );
    }

    public getExceptions(reqBody) {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/get-exceptions';
        const headers = this.apiHelper.getDefaultHeader();

        return this.apiHelper.apiCall(
          url,
          'POST',
          null,
          reqBody,
          headers
        );
    }

    public acquireEmbedSession(reqBody: LookerSignedUrlBody, userAgent: string): Observable<LookerEmbedCookielessSessionData> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/acquire-embed-session';
        const body = {
            user: reqBody,
            userAgent
        }
        return this.apiHelper.post(url, null, body)
    }

    public generateEmbedTokens(body: any): Observable<LookerEmbedCookielessSessionData> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/generate-embed-tokens';
        return this.apiHelper.post(url, null, body)
    }
}
